import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";
import { useDispatch } from "react-redux";
import {
  deleteBadgeAPI,
  getAllBadgesAPI,
} from "../../services/badges/badgeService";
import { setListBadges } from "../../redux/slice/badgesSlice";

const ModalDeleteBadge = ({ open, setOpen, badgeData, type, setLoading }) => {
  const dispatch = useDispatch();
  const handleDelete = async () => {
    try {
      setLoading(true);
      await deleteBadgeAPI(badgeData?._id);
      const responseBadges = await getAllBadgesAPI();
      dispatch(setListBadges({ listBadges: responseBadges }));
      toast.success(
        `Logro ${badgeData?.nameBadge ?? ""} eliminada correctamente.`
      );
      setLoading(false);
      setOpen(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      setOpen(false);
      toast.error(
        `Error al eliminar el logro. Por favor, inténtalo de nuevo. \n ${message}`
      );
    }
  };
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" fontWeight="bold" textAlign={"center"}>
        ¿Deseas eliminar el logro {badgeData?.nameBadge ?? ""}?
      </DialogTitle>
      <DialogContent></DialogContent>
      <DialogActions sx={{ display: "flex", gap: 3 }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>
        <Button
          variant="outlined"
          color="white"
          onClick={handleDelete}
          startIcon={<DeleteForeverIcon />}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalDeleteBadge;
